import React, { useState } from "react";
import { HStack, Text, Box, Image, Flex } from "@chakra-ui/react";
import { ChevronRightIcon } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";
import HomeIcon from "../Images/Home-Icon-Stroke-Stande2.0.svg";
import { a } from "./appColors";

const Crumb = ({ label, onClick }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <Text
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
      cursor="pointer"
      color={hovered ? a.text : a.textSub}
      fontSize="11px"
      fontWeight="400"
      lineHeight="normal"
      transition="color 0.15s ease"
    >
      {label}
    </Text>
  );
};

const BreadcrumbsNav = ({ items }) => {
  const navigate = useNavigate();
  const [homeHover, setHomeHover] = useState(false);
  return (
    <Flex align="center" justify="center">
      <HStack spacing="4px" align="center">
        <Box
          onMouseEnter={() => setHomeHover(true)}
          onMouseLeave={() => setHomeHover(false)}
          onClick={() => navigate("/home")}
          cursor="pointer"
          position="relative"
          display="flex"
          alignItems="center"
          justifyContent="center"
          w="18px"
          h="18px"
        >
          <Image className="app-nav-icon" src={HomeIcon} alt="" w="14px" h="14px" />
          <Box
            position="absolute"
            bottom="-4px"
            w="12px"
            h="2px"
            bg={homeHover ? a.hover : "transparent"}
            borderRadius="1px"
          />
        </Box>
        {items.map((it, idx) => (
          <HStack key={it.label + idx} spacing="4px" align="center">
            <Box as={ChevronRightIcon} w="12px" h="12px" color={a.textMuted} />
            <Crumb label={it.label} onClick={it.onClick} />
          </HStack>
        ))}
      </HStack>
    </Flex>
  );
};

export default BreadcrumbsNav;

